import { Action, ActionReducer } from '@ngrx/store';

import { IUserPrefsState } from '../state';

import { reducer as themesReducer } from './reducer.themes';




export const reducers: ActionReducer<IUserPrefsState, Action>[] = [
	themesReducer,
];
